'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      headingId = _ref.headingId,
      title = _ref.title,
      closeButton = _ref.closeButton,
      noCloseButton = _ref.noCloseButton;

  return _react2.default.createElement(
    'header',
    { className: 'luna-modal__header' },
    _react2.default.createElement(
      'h1',
      { className: 'luna-modal__title', id: headingId },
      title
    ),
    children,
    !noCloseButton && closeButton
  );
};

ModalHeader.propTypes = {
  closeButton: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array]),
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array, _propTypes2.default.string]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array, _propTypes2.default.string]),
  noCloseButton: _propTypes2.default.bool,
  headingId: _propTypes2.default.string
};

exports.default = ModalHeader;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/ModalHeader.js